import React, { useEffect, useState } from "react";
import {
  StyledFrontCard,
  StyledFrontCardSubtitle,
  StyledShopContainer,
  StyledShopContainerGrid,
  StyledShopName,
  StyledTextField,
  StyledTopPart,
} from "./styled";
import {
  Autocomplete,
  Box,
  Button,
  CardContent,
  CardMedia,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Skeleton,
  TextField,
  Typography,
  Modal,
} from "@mui/material";
import {
  boldString,
  boldedText,
  capitalize,
  getInitials,
  px2Rem,
} from "../../utils/functions";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { colors } from "../../theme/colors";
import OkyWomanFull from "../../assets/OkyWomanFull.png";
import OkyWoman from "../../assets/banner persona oky ebi integracion.webp";
import OkyEbiVertical from "../../assets/banner integracion oky ebi logo.webp";
import ErrorPage from "../../components/common/ErrorPage/ErrorPage";
import { CloseOutlined } from "@mui/icons-material";
import { HighlightOffOutlined } from "@mui/icons-material";
import { ModalBox } from "../Buy/styled";
import OkyMallBiBanner from "../../assets/newLine/banner-oky.png";

export default function Catalog() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [errorLoading, setErrorLoading] = useState(false);
  const [shops, setShops] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [textFieldFocus, setTextFieldFocus] = useState(false);
  const [ipError, setIpError] = useState(false);

  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_BE_SERVICE}/oky/shops?s=${searchTerm}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.errorCode === "403") {
          setIpError(true);
        } else {
          setShops(res.shops);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("entramos al catch");
        setErrorLoading(true);
        setLoading(false);
      });
  }, []);

  const shopsList = (shopList) => {
    let list = [];

    if (loading) {
      for (let i = 0; i < 40; i++) {
        list.push(
          <Grid
            item
            xs={6}
            sm={3}
            md={3}
            lg={2}
            xl={2}
            style={{ marginBottom: "2rem" }}
          >
            <Skeleton
              variant="circular"
              width={60}
              height={60}
              animation="wave"
              style={{ margin: "auto" }}
            />
            <Skeleton
              variant="text"
              sx={{ fontSize: "1rem" }}
              animation="wave"
            />
          </Grid>
        );
      }
    } else {
      for (let i = 0; i < shopList.length; i++) {
        list.push(
          <StyledShopContainerGrid
            item
            xs={6}
            sm={3}
            md={3}
            lg={2}
            xl={2}
            style={{ marginBottom: "2rem" }}
            onClick={() => {
              window.scrollTo(0, 0);
              navigate(`/shop/${shops[i].shopId}`);
            }}
          >
            <StyledShopContainer>
              <div
                style={{
                  height: "60px",
                  width: "60px",
                  borderRadius: "50%",
                  margin: "auto",
                }}
              >
                {shops[i].logo === null ? (
                  <StyledShopName>
                    <span>{getInitials(shops[i].shopName)}</span>
                  </StyledShopName>
                ) : (
                  <img
                    style={{
                      height: "100%",
                      width: "100%",
                      borderRadius: "50%",
                    }}
                    src={shops[i].logo}
                    alt={shops[i].shopId}
                  />
                )}
              </div>
            </StyledShopContainer>
            <div className="shopText" style={{ textAlign: "center" }}>
              {shops[i].shopName}
            </div>
          </StyledShopContainerGrid>
        );
      }
    }

    return list;
  };

  if (errorLoading) {
    return <ErrorPage />;
  }

  if (ipError) {
    return (
      <>
        <Modal open="true">
          <ModalBox>
            <HighlightOffOutlined color="error" style={{ fontSize: "5rem" }} />
            <Typography
              variant="h2"
              sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
            >
              Usuario inhabilitado temporalmente
            </Typography>

            <Typography variant="body1" color="primary">
              Las solicitudes con este usuario no están disponibles en este
              momento.
            </Typography>
          </ModalBox>
        </Modal>
      </>
    );
  } else {
    return (
      <>
        <Box style={{ position: "relative" }}>
          <StyledTopPart
            sx={{
              height: { xs: "450px", sm: "350px", md: "350px", lg: "450px" },
            }}
          >
            <Autocomplete
              autoHighlight
              options={shops}
              open={textFieldFocus}
              onOpen={() => setTextFieldFocus(true)}
              onClose={(e) => setTextFieldFocus(false)}
              getOptionLabel={(opt) => opt.shopName}
              renderOption={(props, option) => {
                return (
                  <Box
                    {...props}
                    key={option.shopId}
                    component="li"
                    onClick={() => navigate(`/shop/${option.shopId}`)}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={2} sm={1} alignItems="center">
                        {option.logo === null ? (
                          <StyledShopName size="32">
                            <span>{getInitials(option.shopName)}</span>
                          </StyledShopName>
                        ) : (
                          <img
                            src={option.logo}
                            alt={option.shopId}
                            style={{
                              height: "32px",
                              width: "32px",
                              borderRadius: "50%",
                            }}
                          />
                        )}
                      </Grid>
                      <Grid
                        item
                        style={{
                          borderBottom: `1px solid ${colors.gray.border}`,
                          marginTop: "0.5rem",
                        }}
                        xs={10}
                        sm={11}
                      >
                        {boldedText(option.shopName, searchTerm)}
                      </Grid>
                    </Grid>
                  </Box>
                );
              }}
              style={{ maxWidth: "606px", margin: "auto" }}
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  onClick={() => setTextFieldFocus(true)}
                  placeholder="Busca por establecimiento..."
                  onChange={(e) => setSearchTerm(capitalize(e.target.value))}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: colors.secondary }} />
                      </InputAdornment>
                    ),
                    autoComplete: "new-password",
                    endAdornment: (
                      <InputAdornment position="end">
                        {!textFieldFocus ? (
                          <Button
                            color="secondary"
                            variant="contained"
                            sx={{ borderRadius: "50px", width: "113px" }}
                          >
                            Buscar
                          </Button>
                        ) : null}
                      </InputAdornment>
                    ),
                    onKeyDown: (e) => {
                      if (e.key === "Enter") {
                        e.stopPropagation();
                      }
                    },
                  }}
                />
              )}
            />
          </StyledTopPart>

          <div style={{ maxWidth: "85%", margin: "auto" }}>
            <StyledFrontCard container alignItems="center">
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  padding: { xs: "2rem", sm: "3rem", lg: "2rem" },
                  textAlign: { md: "center" },
                }}
              >
                <Typography variant="h2">
                  ¡Regala felicidad con vales!
                </Typography>
                <StyledFrontCardSubtitle>
                  Envía vales al instante para tus seres queridos
                </StyledFrontCardSubtitle>
              </Grid>
              <Grid
                item
                sm={6}
                textAlign={"center"}
                sx={{
                  backgroundColor: colors.purple.main,
                  backgroundImage: `url(${OkyMallBiBanner})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "100vw",
                  height: "262px",
                  maxHeight: "262px",
                  display: {
                    sm: "none",
                    xs: "none",
                    md: "none",
                    lg: "block",
                    xl: "block",
                  },
                }}
              >
                {/* <img
                  src={OkyMallBiBanner}
                  alt="oky"
                  style={{ width: "100%", height: "100%" }}
                /> */}
              </Grid>
            </StyledFrontCard>
          </div>
        </Box>

        <div style={{ maxWidth: "85%", margin: "auto", position: "relative" }}>
          <Typography
            variant="h3"
            textAlign="center"
            style={{ marginBottom: "2rem" }}
          >
            Establecimientos afiliados
          </Typography>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            {shopsList(shops)}
          </Grid>
        </div>
      </>
    );
  }
}
